import gql from 'graphql-tag';
import { DsrFragments } from '@getaccept/lib-shared/src/library/graphql/dsr.fragments';
import { DealroomQueryKey } from '@getaccept/lib-shared/src/rooms/enums/dealroom-query-key';
import { TimelineFragments } from '@getaccept/dsr-shared/src/api/timeline/graphql/timeline.fragments';

export class DsrQueries {
  static resources = gql`
    query DsrResources(
      $searchTerms: [String!]
      $resourceType: DsrResourceType
      $directory: String
      $limit: Int!
      $offset: Int!
      $sortBy: DsrSortAttribute
      $sortOrder: SortOrder
      $userIds: [String!]
      $includeSubDirectories: Boolean
    ) {
      ${DealroomQueryKey.Resources}(
        searchTerms: $searchTerms
        resourceType: $resourceType
        directory: $directory
        limit: $limit
        offset: $offset
        sortBy: $sortBy
        sortOrder: $sortOrder
        userIds: $userIds
        includeSubDirectories: $includeSubDirectories
      ) {
        resources {
          ...dsrResourceFragment
        }
        totalCount
      }
    }
    ${DsrFragments.resource}
  `;

  static roomsItems = gql`
    query dealrooms(
      $statuses: [DealroomStatus!]
      $userIds: [String!]
      $orderBy: [DealroomOrder!]
      $limit: Int
      $offset: Int
      $searchTerms: [String!]
    ) {
      dealrooms(
        statuses: $statuses
        userIds: $userIds
        orderBy: $orderBy
        limit: $limit
        offset: $offset
        searchTerms: $searchTerms
      ) {
        rooms {
          id
          name
          details {
            value
            companyName
          }
          participants {
            id
            role
            details {
              fullName
              firstName
              lastName
              thumbUrl
              email
              title
              companyName
            }
          }
          createdAt
          status
          latestActivity {
            createdAt
            data {
              ... on DealroomVisitedEventLogData {
                ...visitedEventLogData
              }

              ... on DealroomParticipantCreatedEventLogData {
                ...participantCreatedEventLogData
              }

              ... on DealroomTaskUpdatedEventLogData {
                ...taskUpdatedEventLogData
              }

              ... on DealroomFileUploadedEventLogData {
                ...fileUploadedEventLogData
              }
              ... on DealroomFileDownloadedEventLogData {
                ...fileDownloadedEventLogData
              }

              ... on DealroomContextualCommentReplyCreatedEventLogData {
                ...contextualCommentReplyCreatedEventLogData
              }
              ... on DealroomContextualCommentUpdatedEventLogData {
                ...contextualCommentUpdatedEventLogData
              }

              ... on DealroomConversationMessageEventLogData {
                ...conversationMessageEventLogData
              }
            }
          }
        }
        totalCount
      }
    }
    ${TimelineFragments.visitedEventLogData}
    ${TimelineFragments.participantCreatedEventLogData}
    ${TimelineFragments.taskUpdatedEventLogData}
    ${TimelineFragments.fileUploadedEventLogData}
    ${TimelineFragments.fileDownloadedEventLogData}
    ${TimelineFragments.contextualCommentReplyCreatedEventLogData}
    ${TimelineFragments.contextualCommentUpdatedEventLogData}
    ${TimelineFragments.conversationMessageEventLogData}
  `;

  static sampleTemplates = gql`
    query dsrSampleResources($offset: Int, $limit: Int) {
      dsrSampleResources(offset: $offset, limit: $limit) {
        resources {
          contentId
          title
        }
      }
    }
  `;
}
